import { observable } from "mobx";
import { Type } from "class-transformer";
import InternalReportDownloadResponse from "./internalReportDownloadResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class GetInternalReportDetailResponse {
  id!: string;

  @observable
  reportName!: string;

  @observable
  createdBy!: string;

  @observable
  @Type(() => Date)
  processedAt?: Date;

  @observable
  @Type(() => InternalReportDownloadResponse)
  downloads!: InternalReportDownloadResponse[];
}
